require('../modules/es.global-this');

module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/global-this.js
// module id = 1215
// module chunks = 1